import { CustomValidators } from 'ng2-validation';
import { EncuestaService } from './../../../services/encuesta/encuesta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

const swal = require('sweetalert2');

@Component({
  selector: 'app-subscribirse',
  templateUrl: './subscribirse.component.html',
  styleUrls: ['./subscribirse.component.scss']
})
export class SubscribirseComponent implements OnInit {
  private identificador: string;
  private encuesta: any;
  private form: FormGroup;
  private imagen: string;

  constructor(
    fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private encuestaSrv: EncuestaService,
    private router: Router
  ) {
    this.form = fb.group({
      email: ['', [Validators.required, CustomValidators.email]]
    });
  }

  ngOnInit() {
    this.activatedRoute.params.flatMap((param: any) => {
      this.identificador = param.identificador;

      return this.encuestaSrv.getEncuestaByIdentificador(this.identificador);
    }).subscribe(data => {
      this.encuesta = data;
      this.imagen = `${this.encuestaSrv.getApiUrl()}/imagen-proyecto/${data.proyecto_id}`;
    });
  }

  submitForm($event, form: FormGroup) {
    swal({
      title: 'Aceptando suscripción',
      text: 'Confirmando la suscripción, este proceso puede tardar un poco'
    });

    swal.showLoading();

    this.encuestaSrv
      .suscribe(this.encuesta.id, form.value)
      .subscribe(data => {
        const url = `${location.origin}/cuestionario/${data.codigo_busqueda}`;
        swal({
          type: 'success',
          title: 'Suscripción exitosa',
          showConfirmButton: false,
          html: `<p class="text-left">Usted ha quedado suscrito de forma satisfactoria al cuestionario:
          <blockquote class="pv-sm ph-sm mb0 text-left">
            <h5 class="mv-sm">
              ${this.encuesta.nombre}<br>
              <small>${this.encuesta.descripcion}</small>
            </h5>
          </blockquote>
          </p>
          <p class="text-left">
            <strong>Pinche en el siguiente enlace para completar el cuestionario<br><br>
            <a class="text-success" href='${url}' target="BLANK">${url}</a></strong>
          </p>`
        });

        this.form.reset('');
      });
  }

  encuestaAnonima() {
    swal({
      title: 'Iniciando cuestionario',
      text: 'Estamos cargando el cuestionario, este proceso puede tardar un poco'
    });

    swal.showLoading();

    this.encuestaSrv
      .suscribe(this.encuesta.id, {email: this.guid()})
      .subscribe(data => {
        setTimeout(() => {
          this.router.navigateByUrl(`cuestionario/${data.codigo_busqueda}`);
        }, 2000);

        this.form.reset('');
      });
  }

  guid() {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };

    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/encuesta/subscribirse/subscribirse.component.ts